import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common'; // Importa esto

@Injectable({
  providedIn: 'root'
})
export class CssSwitcherService {
  private linkElement!: HTMLLinkElement;
  private readonly basePath = 'assets/css/';
  private isBrowser: boolean;

 constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.linkElement = this.createLinkElement();
      this.loadDefaultCss();
    }
  }

  private createLinkElement(): HTMLLinkElement {

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.id = 'dynamic-theme';
    document.head.appendChild(link);
    return link;
  }

  private loadDefaultCss(): void {

    if (this.linkElement) {
      this.linkElement.href = `${this.basePath}default.css`;
    }
  }

  switchCss_old(cssFile: string): Promise<boolean> {
    return new Promise((resolve) => {
      const newLink = document.createElement('link');
      newLink.rel = 'stylesheet';
      newLink.type = 'text/css';
      newLink.href = `${this.basePath}${cssFile}.css`;
      newLink.id = 'dynamic-theme-new';

      newLink.onload = () => {
        const oldLink = document.getElementById('dynamic-theme');
        if (oldLink) oldLink.remove();
        newLink.id = 'dynamic-theme';
        resolve(true);
      };

      newLink.onerror = () => {
        newLink.remove();
        console.error(`Failed to load CSS: ${cssFile}.css`);
        resolve(false);
      };

      document.head.appendChild(newLink);
    });
  }

  switchCss(cssFile: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.isBrowser) {
        const newLink = document.createElement('link');
        newLink.rel = 'stylesheet';
        newLink.type = 'text/css';
        newLink.href = `${this.basePath}${cssFile}.css`;
        newLink.id = 'dynamic-theme-new';

        newLink.onload = () => {
          const oldLink = document.getElementById('dynamic-theme');
          if (oldLink) oldLink.remove();
          newLink.id = 'dynamic-theme';
          resolve(true);
        };

        newLink.onerror = () => {
          newLink.remove();
          console.error(`Failed to load CSS: ${cssFile}.css`);
          resolve(false);
        };

        document.head.appendChild(newLink);
      } else {
        resolve(true);
      }
    });
  }  

}
